import { API_CONFIG } from '@/config/api';

/**
 * Resolves a data-source endpoint stored in entity metadata to a request path.
 *
 * Endpoints are persisted as bare PostgREST resource names ("entities") so that
 * gateway routing is never baked into content. Pre-cutover rows may still hold a
 * full path, which is passed through unchanged.
 */
export const resolveDataEndpoint = (endpoint: string): string => {
  if (endpoint.startsWith('/') || endpoint.startsWith('http')) {
    return endpoint;
  }
  return `${API_CONFIG.DATA_API_BASE_PATH}/${endpoint}`;
};
